import React from 'react';

const LandingMantenimiento = () => {
  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-4 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary-500/20 rounded-full blur-[120px] animate-pulse" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-magenta-500/20 rounded-full blur-[120px] animate-pulse delay-1000" />
      </div>

      <div className="z-10 text-center max-w-2xl mx-auto space-y-8">
        {/* Logo or Icon */}
        <div className="mx-auto w-20 h-20 bg-white/5 backdrop-blur-xl rounded-2xl flex items-center justify-center border border-white/10 shadow-2xl mb-8 group hover:scale-105 transition-transform duration-500">
           <img src="/logo-visiopadel.png" alt="Visiopadel" className="w-12 h-12 object-contain opacity-80 group-hover:opacity-100 transition-opacity" />
        </div>

        {/* Main Text */}
        <div className="space-y-4">
          <h1 className="text-4xl md:text-6xl font-bold text-white tracking-tight">
            Algo <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-400 to-magenta-500">extraordinario</span> está por llegar.
          </h1>
          <p className="text-lg md:text-xl text-slate-400 max-w-lg mx-auto leading-relaxed">
            Estamos actualizando nuestra plataforma para ofrecerte una experiencia de pádel revolucionaria. 
          </p>
        </div>

        {/* Status Pill */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-md">
          <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
          <span className="text-sm font-medium text-slate-300">En mantenimiento programado</span>
        </div>
      </div>

       {/* Secret Login Trigger (Invisible to average user, but clickable if you know where) */}
      <div className="absolute bottom-8 right-8 transition-opacity duration-700">
          <a href="/login" className="text-slate-700 hover:text-slate-500 cursor-pointer text-2xl" p-4>
              🔒
          </a>
      </div>
    </div>
  );
};

export default LandingMantenimiento;
